import * as D from "protobufjs/minimal.js";
import "./countries.js";
import "./languages.js";
import "./time.js";
const L = "default" in D ? D.default : D;
var T;
(function(E) {
  E[E.ALPHA = 10] = "ALPHA", E[E.BETA = 20] = "BETA", E[E.PRERELEASE = 30] = "PRERELEASE", E[E.RELEASE_CANDIDATE = 40] = "RELEASE_CANDIDATE";
})(T || (T = {}));
var O;
(function(E) {
  E[E.REGISTER = 1] = "REGISTER", E[E.LEGACY_REGISTER = 2] = "LEGACY_REGISTER", E[E.WALLET = 3] = "WALLET", E[E.TAXIDRIVER = 4] = "TAXIDRIVER", E[E.DASHBOARD = 5] = "DASHBOARD", E[E.CASH = 6] = "CASH", E[E.APPOINTMENTS = 7] = "APPOINTMENTS";
})(O || (O = {}));
var f;
(function(E) {
  E[E.DEVELOPMENT = 0] = "DEVELOPMENT", E[E.ALPHA = 10] = "ALPHA", E[E.DOGFOOD = 15] = "DOGFOOD", E[E.BETA = 20] = "BETA", E[E.RELEASE = 30] = "RELEASE";
})(f || (f = {}));
var C;
(function(E) {
  E[E.IOS = 0] = "IOS", E[E.ANDROID = 1] = "ANDROID", E[E.JAVASCRIPT = 2] = "JAVASCRIPT";
})(C || (C = {}));
var H;
(function(E) {
  E[E.PORTRAIT = 0] = "PORTRAIT", E[E.PORTRAIT_UPSIDE_DOWN = 1] = "PORTRAIT_UPSIDE_DOWN", E[E.LANDSCAPE_LEFT = 2] = "LANDSCAPE_LEFT", E[E.LANDSCAPE_RIGHT = 3] = "LANDSCAPE_RIGHT", E[E.FACE_UP = 4] = "FACE_UP", E[E.FACE_DOWN = 5] = "FACE_DOWN", E[E.SQUARE = 6] = "SQUARE";
})(H || (H = {}));
var u;
(function(E) {
  E[E.WIFI = 0] = "WIFI", E[E.CELL = 1] = "CELL", E[E.WIRED = 2] = "WIRED", E[E.WIMAX = 3] = "WIMAX", E[E.NONE = 999] = "NONE", E[E.UNKNOWN = 1e3] = "UNKNOWN";
})(u || (u = {}));
var n;
(function(E) {
  E[E.O1 = 1] = "O1", E[E.S1 = 2] = "S1", E[E.R4 = 3] = "R4";
})(n || (n = {}));
var G;
(function(E) {
  E[E.FIRMWARE_HASH_CHECK_FAILED = 1] = "FIRMWARE_HASH_CHECK_FAILED", E[E.KEY_AND_HARDWARE_ID_HASH_CHECK_FAILED = 2] = "KEY_AND_HARDWARE_ID_HASH_CHECK_FAILED", E[E.TAMPER_DETECT_TRIGGERED = 4] = "TAMPER_DETECT_TRIGGERED", E[E.COUNTER_FAILED = 8] = "COUNTER_FAILED";
})(G || (G = {}));
var U;
(function(E) {
  E[E.COLD_LAUNCH = 1e3] = "COLD_LAUNCH", E[E.BACKGROUND_LAUNCH = 1001] = "BACKGROUND_LAUNCH", E[E.NOT_LOGGED_IN = 1002] = "NOT_LOGGED_IN", E[E.INJECTION_FINISHED = 1003] = "INJECTION_FINISHED", E[E.GOT_LOCATION_FIX = 1004] = "GOT_LOCATION_FIX", E[E.MUST_ENABLE_TABS = 1005] = "MUST_ENABLE_TABS", E[E.LAUNCHED_TO_WALLET = 2e3] = "LAUNCHED_TO_WALLET", E[E.QR_CODE_SHOWN = 2001] = "QR_CODE_SHOWN", E[E.DIRECTORY_CREATED = 2002] = "DIRECTORY_CREATED", E[E.DIRECTORY_LOADED = 2003] = "DIRECTORY_LOADED", E[E.REGISTER_AUTHORIZE = 3e3] = "REGISTER_AUTHORIZE", E[E.API_REQUEST = 1e4] = "API_REQUEST";
})(U || (U = {}));
function W() {
  return {
    $type: "squareup.common.client.Version",
    major: void 0,
    minor: void 0,
    revision: void 0,
    prereleaseType: void 0,
    prerelease: void 0,
    buildId: void 0
  };
}
const F = {
  $type: "squareup.common.client.Version",
  encode(E, I = L.Writer.create()) {
    return E.major !== void 0 && I.uint32(8).uint32(E.major), E.minor !== void 0 && I.uint32(16).uint32(E.minor), E.revision !== void 0 && I.uint32(24).uint32(E.revision), E.prereleaseType !== void 0 && I.uint32(32).int32(E.prereleaseType), E.prerelease !== void 0 && I.uint32(40).uint32(E.prerelease), E.buildId !== void 0 && I.uint32(50).string(E.buildId), I;
  },
  decode(E, I) {
    const A = E instanceof L.Reader ? E : L.Reader.create(E);
    let d = I === void 0 ? A.len : A.pos + I;
    const N = W();
    for (; A.pos < d; ) {
      const R = A.uint32();
      switch (R >>> 3) {
        case 1:
          if (R !== 8)
            break;
          N.major = A.uint32();
          continue;
        case 2:
          if (R !== 16)
            break;
          N.minor = A.uint32();
          continue;
        case 3:
          if (R !== 24)
            break;
          N.revision = A.uint32();
          continue;
        case 4:
          if (R !== 32)
            break;
          N.prereleaseType = A.int32();
          continue;
        case 5:
          if (R !== 40)
            break;
          N.prerelease = A.uint32();
          continue;
        case 6:
          if (R !== 50)
            break;
          N.buildId = A.string();
          continue;
      }
      if ((R & 7) === 4 || R === 0)
        break;
      A.skipType(R & 7);
    }
    return N;
  },
  create(E) {
    return F.fromPartial(E ?? {});
  },
  fromPartial(E) {
    const I = W();
    return I.major = E.major ?? void 0, I.minor = E.minor ?? void 0, I.revision = E.revision ?? void 0, I.prereleaseType = E.prereleaseType ?? void 0, I.prerelease = E.prerelease ?? void 0, I.buildId = E.buildId ?? void 0, I;
  }
};
export {
  U as ApplicationState_State,
  u as Connection_Type,
  H as Device_Orientation,
  C as Device_Platform,
  O as Product_Application,
  f as Product_BuildType,
  G as Reader_Failure,
  n as Reader_Type,
  F as Version,
  T as Version_PrereleaseType
};
